import React from 'react';
import Configurator from './Configurator.jsx';
import styles from './LEDStripConfigurator.styl';
import Image from './ui/features/Image.jsx';
import LEDTable from './ui/features/LEDTable.jsx';
import Dropdown from './ui/features/DropDownWithPictures.jsx';
import Button from './ui/button/Button.jsx'
import jQuery from 'jquery'



class LEDStripConfigurator extends Configurator
{
	componentDidMount() {
		this.getItemList()
		this.getProductList()
	}

	// Конструктор
	constructor(props) {

		super(props);
		this.db = null;
		this.state = jQuery.extend({}, this.state, {
			specList: [],													// спецификация
			itemList:[],													// корзина (отфильтрованные товары)
			items: [],
			showAdditionVoltInfo:false,						// вспомогательный флаг, разрешающий или запрещающий показывать дополнительную информаию
			showAdditionPowerInfo:false,					// вспомогательный флаг, разрешающий или запрещающий показывать дополнительную информаию
			summ: 0,

			showAdditionalFilters:false,					// вспомогательный флаг, разрешающий или запрещающий показывать дополнительные филтры
			addPlug: false,												// флаг, разрешающий добавить в список товаров заглушку (для 220 В)
			addStaple: false,											// флаг, разрешающий добавить в список товаров скобу (для 220 В)
			db:[],																// массив со списокм базы данных


			// Область фильтров
			// Вольтаж
			voltageOptions:[],										// варианты выбора напряжения
			filterVoltage: 'Выбрать',							// Выбранное напряжение питания

			//IP
			ipOptions:[],													// варианты выбора ip
			filterIP: 'Выбрать',									  		// Выбранное ip

			//Цвет свечения
			colorOptions:[],											// варианты выбора цвета свечения
			filterColor: 'Выбрать',								// Выбранный цвет свечения

			// Серия
			siriesOptions:[],											// варианты выбора серии
			filterSiries: 'Выбрать',							// Выбранная серия

			// Количество светодиодов
			lightsOptions:[],											// варианты выбора серии
			filterLights: 'Выбрать',							// Выбранная серия

			power: 0,
			width: 0,
			length: 0,
			controllOptions:[],
			filterControll: 'Выбрать',


			controllColorOptions:[],
			filterControllColor: 'Выбрать',


			connectorOptions:[],
			filterConnector: 'Выбрать',

			profileOptions:[],
			filterProfile: 'Выбрать',


			// Область детализированных списков
			stripList:[],													// список светодиодных лент
			driverList:[],												// список драйверов
			// Область доп списков
			controllList:[],											// список контрллеров
			amplifierList:[],											// список усилителей
			plugList:[],													// список заглушку
			stapleList:[],												// список скобу
			profileList:[],												// список профилей
			kitList:[],														// список наборов для монтажа
			connectorList:[],											// список коннекторов

			prevItemList:[],

			enableInput: false

		});

		this.onListItemCheck 								= this.onListItemCheck.bind(this);
		this.onDelete 											= this.onDelete.bind(this);
		this.onChangeQuantity								= this.onChangeQuantity.bind(this);
		this.onBtnExcelClick 								= this.onBtnExcelClick.bind(this);
		this.onBtnPluginClick 							= this.onBtnPluginClick.bind(this);
		this.onBtnRedirectClick 						= this.onBtnRedirectClick.bind(this);
		this.addBasket 											= this.addBasket.bind(this);
		this.toggleAddFilters								= this.toggleAddFilters.bind(this);
		this.getAddCustomDropdown						= this.getAddCustomDropdown.bind(this);
		this.getAddLable										= this.getAddLable.bind(this);
		this.getAddCheckBox									= this.getAddCheckBox.bind(this);
		this.onAddPlugChange								= this.onAddPlugChange.bind(this);
		this.onAddStapleChange							= this.onAddStapleChange.bind(this);
		this.getItemList										= this.getItemList.bind(this);
		this.onVoltageChange								= this.onVoltageChange.bind(this);
		this.getArrayFromAttribute					= this.getArrayFromAttribute.bind(this);
		this.onIPChange											= this.onIPChange.bind(this);
		this.onColorChange									= this.onColorChange.bind(this);
		this.onSeriesChange									= this.onSeriesChange.bind(this);
		this.getSeiesOptions								= this.getSeiesOptions.bind(this);
		this.getFilteredArray								= this.getFilteredArray.bind(this);
		this.onLengthInput									= this.onLengthInput.bind(this);
		this.changeFilterOptions						= this.changeFilterOptions.bind(this);
		this.onlightChange									= this.onlightChange.bind(this);
		this.getPowerOptions								= this.getPowerOptions.bind(this);
		this.getAddFilteredArray						= this.getAddFilteredArray.bind(this);
		this.changeAddFilterOptions					= this.changeAddFilterOptions.bind(this);

		this.onControllChange								= this.onControllChange.bind(this);
		this.onControllColorChange					= this.onControllColorChange.bind(this);
		this.onConnectorChange							= this.onConnectorChange.bind(this);
		this.onProfileChange								= this.onProfileChange.bind(this);
		this.getProductList									= this.getProductList.bind(this);



	}

	// ++ Обязательные методы для работы конфигуратора
	// Получение стилей
	getCustomStyles() {
		return styles;
	}

	// Получение типа
	getType() {
		return 'led_strip';
	}
	// -- Обязательные методы для работы конфигуратора


	// ++ Методы спецификации таблицы
	onListItemCheck(item) {

		if (this.state.item && (item.Code === this.state.item[0].Code)) {
			return;
		}

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemNSI',
				article: item.Code
			},
			item => {
				this.setState({item:item});
			}
		);
}

 // При удалении элемента из таблицы
	onDelete(item) {
		this.setState((prevState) => {
			return {
				...prevState,
				specList: prevState.specList.filter((el) => el.Code !== item.Code),
			}
		}, ()=>{
			let specList = this.state.specList
			let summ = 0
			if(specList.length){
				summ= specList.map(item => item.price).reduce((previousValue, currentValue) => {
					return previousValue + currentValue
				}).toFixed(2)
			}
			this.setState({summ})
			this.doAddToCart(specList)
		})
	}

	// Изменение количества позиции
	onChangeQuantity(item, value) {
		this.setState(prevState => {
			const newBasket = prevState.specList.map(i => {
				if (i.Code === item.Code) {
					i.count = value
					i.sum = value*item.price
				}
				return i
			})

			let summ = prevState.specList.map(item => item.price*item.count).reduce((previousValue, currentValue) => {
				return previousValue + currentValue
			}).toFixed(2)

			return {
				specList: newBasket,
				summ
			}
		},()=>{
			this.doAddToCart(this.state.specList)
		})
	}

	// добавить элемент в корзину
	addBasket(item) {

		this.setState(prevState => {
			const specList = [...prevState.specList]
			if (specList.some(i => i.Code === item.Code)) {
				specList.map(i => {
					if (i.Code === item.Code) {
						i.count = Number(i.count) + 1
						i.sum = i.price*i.count
					}
					return i
				})
			} else {
				item.count = 1
				item.sum = item.count*item.price
				specList.push(item)
			}

			let summ = specList.map(item => item.price*item.count).reduce((previousValue, currentValue) => {
				return previousValue + currentValue
			}).toFixed(2)

			return {specList, summ}
		},()=>{
			this.doAddToCart(this.state.specList)
		})
	}

// -- Методы таблицы


	// Чекбоксы

	toggleAddFilters(){
		let voltage = this.state.filterVoltage
		let lights = this.state.filterLights
		let ip = this.state.filterIP
		let color = this.state.filterColor
		let series = this.state.filterSiries
		let power = this.state.power
		let width = this.state.width


		if(ip === 'Выбрать'
			|| color === 'Выбрать'
			 || series === 'Выбрать'
			 || voltage === 'Выбрать'
			 || lights === 'Выбрать'){
			alert('Необходимо выбрать все фильтры')
			return
		}

		// обработка отображения
		let showAdditionalFilters = !this.state.showAdditionalFilters
		let elemTable = document.getElementById('NoBucket')
		let elemBlock = document.getElementById('Addition')

		let visibility
		let top
		let height
		if(showAdditionalFilters){
			top = '557px'
			height = "254px"
			visibility = "visible"
		}else{
			top = "327px"
			height = "484px"
			visibility = "hidden"
		}
		elemTable.style.top = top
		elemTable.style.height = height
		elemBlock.style.visibility = visibility

		// Управление списком товаров
		let itemList = this.getFilteredArray()

		if(voltage !== null && voltage !== 'Выбрать' && showAdditionalFilters){
			itemList = this.getAddFilteredArray(itemList, width, 'width')
			itemList = this.getAddFilteredArray(itemList, width, 'width')
			this.changeAddFilterOptions(itemList)
		}

		if(power !== 0){
			let powerItemList = this.getPowerOptions(voltage, power)
			itemList = itemList.concat(powerItemList)
		}

		this.setState({
			itemList,
			showAdditionalFilters
		})
	}

	onAddPlugChange(){

		let addPlug = !this.state.addPlug

		let voltage = this.state.filterVoltage
		let power = this.state.power

		let itemList = this.getFilteredArray()
		if(power !== 0){
			let powerItemList = this.getPowerOptions(voltage, power)
			itemList = itemList.concat(powerItemList)
		}
		itemList = this.getAddFilteredArray(itemList, addPlug, 'addPlug')

		this.setState({
				addPlug,
				itemList
		})
	}

	onAddStapleChange(){

		let addStaple = !this.state.addStaple

		let voltage = this.state.filterVoltage
		let power = this.state.power

		let itemList = this.getFilteredArray()
		if(power !== 0){
			let powerItemList = this.getPowerOptions(voltage, power)
			itemList = itemList.concat(powerItemList)
		}
		itemList = this.getAddFilteredArray(itemList, addStaple, 'addStaple')

		this.setState({
			addStaple,
			itemList
		})
	}


	// ++ Дополнительные фильтры


	// Подзаголовки
	getAddLable(){
		let elements = [];

		// Контроллеры
		elements.push(<div className={styles.controlAddTitle}>Контроллер</div>)
		// Коннектор
		elements.push(<div className={styles.connectAddTitle}>Коннектор</div>)
		// Профиль
		elements.push(<div className={styles.shapetAddTitle}>Профиль</div>)
		return elements;
	}

	// Чекбоксы
	getAddCheckBox(){
		let elements = [];

		// Использовать загулшку
		elements.push(
			<React.Fragment>
				<label className={styles.addPlug}>
					Добавить заглушку:
				</label>
				<input
					className={styles.addPlugCheckBox}
					type="checkbox"
					checked={this.state.addPlug}
					onChange={this.onAddPlugChange}/>
			</ React.Fragment>
		)

		// Использовать скобу
		elements.push(
			<React.Fragment>
				<label className={styles.addStaple}>
					Добавить скобу:
				</label>
				<input
					className={styles.addStapleCheckBox}
					type="checkbox"
					checked={this.state.addStaple}
					onChange={this.onAddStapleChange}/>
			</ React.Fragment>
		)

		return elements;
	}

	// -- Дополнительные фильтры

// ++ Дропдауны

	//Основная секция
	getCustomDropdown() {
		let elements = [];

		// Напряжение питания, В
		elements.push(
			<div>
				<span className={styles.voltageLable}>Напряжение питания, В:</span>
				<select
					className={styles.voltage}
					value={'Выбрать'}
					onChange={this.onVoltageChange}

				> {this.state.voltageOptions.length > 0
					? this.state.voltageOptions.map((option, index) => {
						return (
							<option value={option} key={index}>{option} </option>)
					})
					: <option value="Выбрать">Выбрать</option>
					}

				</select>
			</div>)

		// IP
		elements.push(
			<div>
				<span className={styles.ipLable}>IP:</span>
				<select
					className={styles.ip}
					disabled={!(this.state.ipOptions.length>1)}
					onChange={this.onIPChange}
					value={this.state.filterIP}
				>{this.state.ipOptions.length > 0
					? this.state.ipOptions.map((option, index) => {
						return (
							<option value={option} key={index}>{option}</option>)
					})
					: <option value="Выбрать">Выбрать</option>
				}
				</select>
			</div>)

		// Серия
		elements.push(
			<div>
				<span className={styles.seriesLable}>Серия:</span>
				<select
					className={styles.series}
					disabled={!(this.state.siriesOptions.length>1)}
					onChange={this.onSeriesChange}
					value={this.state.filterSiries}
				>{this.state.siriesOptions.length > 0
					? this.state.siriesOptions.map((option, index) => {
						return (
							<option value={option.description} key={index}>{option.description}</option>)
					})
					: <option value="Выбрать">Выбрать</option>
				}
				</select>
			</div>)

		// Цвет
		elements.push(
			<div>
				<span className={styles.colorLable}>Цвет свечения:</span>
				<select
					className={styles.color}
					disabled={!(this.state.colorOptions.length>1)}
					onChange={this.onColorChange}
					value={this.state.filterColor}
				>{this.state.colorOptions.length > 0
					? this.state.colorOptions.map((option, index) => {
						return (
							<option value={option} key={index}>{option}</option>)
					})
					: <option value="Выбрать">Выбрать</option>
				}</select>
			</div>)

		// Лампочек на м
		elements.push(
			<div>
				<span className={styles.lightsLable}>Кол-во лампочек:</span>
				<select
					className={styles.lights}
					disabled={!(this.state.lightsOptions.length>1)}
					onChange={this.onlightChange}
					value={this.state.filterLights}
				>{this.state.lightsOptions.length > 0
					? this.state.lightsOptions.map((option, index) => {
						return (
							<option value={option} key={index}>{option}</option>)
					})
					: <option value="Выбрать">Выбрать</option>
				}</select>
			</div>)


		return elements;
	}

	//Дополнительные дропдауны
	getAddCustomDropdown(){
		let elements = [];

		// Канал связи
		elements.push(
			<div>
				<span className={styles.chanelLable}>Канал связи:</span>
				<select
					className={styles.chanel}
					disabled={!(this.state.controllOptions.length>1)}
					onChange={this.onControllChange}
				>{this.state.controllOptions.length > 0
					? this.state.controllOptions.map((option, index) => {
						return (
							<option value={option} key={index}>{option}</option>)
					})
					: <option value="Выбрать">Выбрать</option>
				}</select>
			</div>)

		// Цвет пульта
		elements.push(
			<div>
				<span className={styles.controlColorLable}>Цвет пульта:</span>
				<select
					className={styles.controlColor}
					disabled={!(this.state.controllColorOptions.length >1)}
					onChange={this.onControllColorChange}
				>{this.state.controllColorOptions.length > 0
					? this.state.controllColorOptions.map((option, index) => {
						return (
							<option value={option} key={index}>{option}</option>)
					})
					: <option value="Выбрать">Выбрать</option>
				}</select>
			</div>)

		// Разъем
		elements.push(
			<div>
				<span className={styles.connectorLable}>Разъем</span>
				<select
					className={styles.connector}
					disabled={!(this.state.connectorOptions.length>1)}
					onChange={this.onConnectorChange}
				>{this.state.connectorOptions.length > 0
					? this.state.connectorOptions.map((option, index) => {
						return (
							<option value={option} key={index}>{option}</option>)
					})
					: <option value="Выбрать">Выбрать</option>
				}</select>
			</div>)

		return elements;
	}

	// ++ Обработка Дропдаунов

	onVoltageChange(event){


		let voltage = event.target.value
		let colorOptions = ['Выбрать']
		let ipOptions = ['Выбрать']
		let siriesOptions = {num:0, description:'Выбрать'}
		let lightsOptions = ['Выбрать']
		let itemList = this.state.stripList

		if(this.state.showAdditionalFilters){

			// обработка отображения
			let elemTable = document.getElementById('NoBucket')
			let elemBlock = document.getElementById('Addition')

			let top = "327px"
			let height = "484px"
			let visibility = "hidden"

			elemTable.style.top = top
			elemTable.style.height = height
			elemBlock.style.visibility = visibility

		}
		// Заполняем филтры
		if (voltage !== 'Выбрать'){

			// Получить отфильтрованный массив светодиодных лент
			itemList = this.getFilteredArray(voltage, 'voltage')

			this.changeFilterOptions(itemList, voltage, 'voltage')
			return this.setState({
				itemList,
				filterIP:'Выбрать',
				filterColor:'Выбрать',
				filterLights:'Выбрать',
				filterSiries:'Выбрать',
				filterVoltage:voltage,
				showAdditionalFilters: false,
				power: 0,
				length:0,
			})
		}

		return this.setState({
			itemList,
			colorOptions,
			siriesOptions,
			ipOptions,
			lightsOptions,
			filterIP:'Выбрать',
			filterColor:'Выбрать',
			filterLights:'Выбрать',
			filterSiries:'Выбрать',
			filterVoltage:'Выбрать',
			power: 0,
			showAdditionalFilters: false,
			length:0,
		})


	}

	onIPChange(event){
		let ip = event.target.value
		let itemList = this.getFilteredArray(ip, 'ip')

		this.changeFilterOptions(itemList, ip, 'ip')

		this.setState({
			filterIP: ip,
			itemList
		})
	}

	onColorChange(event){

		let color = event.target.value
		let itemList = this.getFilteredArray(color, 'color')

		this.changeFilterOptions(itemList, color, 'color')

		this.setState({
			filterColor: color,
			itemList
		})
	}

	onSeriesChange(event){

		let series = event.target.value
		let itemList = this.getFilteredArray(series, 'series')

		this.changeFilterOptions(itemList, series, 'series')

		this.setState({
			filterSiries: series,
			itemList
		})

	}

	onlightChange(event){
		let lights = event.target.value
		let itemList = this.getFilteredArray(lights, 'lights')
		this.changeFilterOptions(itemList, lights, 'lights')
		this.setState({
			filterLights: lights,
			itemList
		})
	}

	// -- Обработка Дропдаунов

	// ++ Обработка дополнительных Дропдаунов

	onControllChange(event){

		let voltage = this.state.filterVoltage
		let power = this.state.power

		let control = event.target.value
		let itemList = this.getFilteredArray()
		itemList = this.getAddFilteredArray(itemList, control, 'control')
		this.changeAddFilterOptions(itemList,control, 'control')

		if(power !== 0){
			let powerItemList = this.getPowerOptions(voltage, power)
			itemList = itemList.concat(powerItemList)
		}

		this.setState({
			filterControll: control,
			itemList
		})

	}

	onControllColorChange(event){

		let voltage = this.state.filterVoltage
		let power = this.state.power
		let controlColour = event.target.value

		let itemList = this.getFilteredArray()
		itemList = this.getAddFilteredArray(itemList, controlColour, 'controlColour')
		this.changeAddFilterOptions(itemList, controlColour, 'controlColour')

		if(power !== 0){
			let powerItemList = this.getPowerOptions(voltage, power)
			itemList = itemList.concat(powerItemList)
		}

		this.setState({
			filterControllColor: controlColour,
			itemList
		})

	}

	onConnectorChange(event){

		let connector = event.target.value

		let voltage = this.state.filterVoltage
		let power = this.state.power

		let itemList = this.getFilteredArray()
		itemList = this.getAddFilteredArray(itemList, connector, 'connector')
		this.changeAddFilterOptions(itemList, connector, 'connector')

		if(power !== 0){
			let powerItemList = this.getPowerOptions(voltage, power)
			itemList = itemList.concat(powerItemList)
		}

		this.setState({
			filterConnector: connector,
			itemList
		})

	}

	onProfileChange(profile){

		let voltage = this.state.filterVoltage
		let power = this.state.power

		let itemList = this.getFilteredArray()
		itemList = this.getAddFilteredArray(itemList, profile, 'profile')
		this.changeAddFilterOptions(itemList, profile, 'profile')

		if(power !== 0){
			let powerItemList = this.getPowerOptions(voltage, power)
			itemList = itemList.concat(powerItemList)
		}

		this.setState({
			filterProfile: profile,
			itemList
		})

	}

	// -- Обработка дополнительных Дропдаунов


// -- Дропдауны

	// ++ Обработка события изменения длины
	onLengthInput(event){

		let series = this.state.filterSiries
		let voltage = this.state.filterVoltage
		let ip = this.state.filterIP
		let color = this.state.filterColor
		let lights = this.state.filterLights

		if(this.state.itemList.length > 1 && (ip === 'Выбрать'
			|| color === 'Выбрать'
			|| series === 'Выбрать'
			|| voltage === 'Выбрать'
			|| lights === 'Выбрать')){
			alert('Необходимо выбрать все фильтры')
			event.target.value = 0
			return
		}

		let length = event.target.value
		let item = this.state.itemList[0]
		let mult = item.Features.filter(item => {
			return item.Attribute === "Мощность источников света на 1 метр погонный Вт"
		})[0].value

		let width = item.Features.filter(item => {
			return item.Attribute === "Ширина мм"
		})[0].value

		let power = Math.round(mult*length*1.25)

		let powerItemList = this.getPowerOptions(voltage, power)

		let itemList = this.getFilteredArray(power, 'power').concat(powerItemList)

		this.setState({
			itemList,
			power,
			width,
			length
		})

	}
	// -- Обработка события изменения длины



	// ++ Служебные функции
	getItemList(){

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'led_strip',
				action: 'getItemListNSI',
				groupId:'10.01.02'
			},
			items => {

				let db = items.map(item => {return{...item, article:item.Code}})

				const newArr = items.reduce((counter, item) =>{
					if(item.name.startsWith("Лента")) counter.stripList.push({...item, article:item.Code})
					if(item.name.startsWith("Коннектор")) counter.connectorList.push({...item, article:item.Code})
					if(item.name.startsWith("Драйвер")) counter.driverList.push({...item, article:item.Code})
					if(item.name.startsWith("Контроллер")) counter.controllList.push({...item, article:item.Code})
					if(item.name.startsWith("Магистральный")) counter.amplifierList.push({...item, article:item.Code})
					if(item.name.startsWith("Заглушка")) counter.plugList.push({...item, article:item.Code})
					if(item.name.startsWith("Скоба")) counter.stapleList.push({...item, article:item.Code})
					if(item.name.startsWith("Профиль")) counter.profileList.push({...item, article:item.Code})
					if(item.name.startsWith("Набор")) counter.kitList.push({...item, article:item.Code})

					return counter
				},{
					stripList:[],
					connectorList:[],
					driverList:[],
					controllList:[],
					amplifierList:[],
					plugList:[],
					stapleList:[],
					profileList:[],
					kitList:[],
				})

				newArr.stripList = newArr.stripList.map(item =>{
					let color = item.Features.filter(item =>{return item.Attribute === 'Цвет_Name'})
					return {
						...item,
						color: color[0].value
					}
				}).map(item =>{
					let color = item.color
					if(color === 'Белый'){
						let heate = item.Features.filter(item =>{return item.Attribute === 'Категория цветности света_Name'})
						if (heate[0].value.startsWith('Холодный дневной')){
							color = 'Холодный дневной'
						} else if(heate[0].value.startsWith('Теплый')){
							color = 'Тёплый белый'
						}
					}
					return {
						...item,
						color:color
					}
				})

				newArr.profileList = newArr.profileList.map(item => {
					let height = 0
					let width = 0
					let length = 0
					let heightArr = item.Features.filter(item => {return item.Attribute === 'Высота мм'})
					let widthArr  = item.Features.filter(item => {return item.Attribute === 'Ширина мм'})
					let lengthArr  = item.Features.filter(item => {return item.Attribute === 'Длина мм'})
					if (heightArr.length>0 && heightArr.length>0 && heightArr.length>0){
						height = heightArr[0].value
						width = widthArr[0].value
						length = lengthArr[0].value
					}
					let option =  width + '-' + height + '-' + length
					let img = ''
					switch (width + '-'){
						case '15,5-': img="first"; break;
						case '17-': img="second"; break;
						case '18,1-': img="third"; break;
						case '18,8-': img="fource"; break;
						case '21,5-': img="fifth"; break;
					}
					return {
						...item,
						option:option,
						img:img
					}
				})

				let voltageOptions = this.getArrayFromAttribute(newArr.stripList, 'Напряжение лампы В')

				this.setState({
					db: db,
					stripList: newArr.stripList,
					connectorList: newArr.connectorList,
					driverList: newArr.driverList,
					controllList: newArr.controllList,
					amplifierList: newArr.amplifierList,
					plugList: newArr.plugList,
					stapleList: newArr.stapleList,
					profileList: newArr.profileList,
					kitList:newArr.kitList,
					voltageOptions:voltageOptions,

				})
			}
		);

	}

	getProductList(){

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'led_strip',
				action: 'getProductListNSI',
				groupId:'10.01.02'
			},
			items => {

				let product = items
				let db = this.state.db

				db = db.map(item =>{
					let price = product.filter(product =>(item.Code === product.art))[0].price
					return{...item, price:price}
				})

				const newArr = db.reduce((counter, item) =>{

					if(item.name.startsWith("Лента")) counter.stripList.push({...item, article:item.price})
					if(item.name.startsWith("Коннектор")) counter.connectorList.push({...item, article:item.price})
					if(item.name.startsWith("Драйвер")) counter.driverList.push({...item, article:item.price})
					if(item.name.startsWith("Контроллер")) counter.controllList.push({...item, article:item.price})
					if(item.name.startsWith("Магистральный")) counter.amplifierList.push({...item, article:item.price})
					if(item.name.startsWith("Заглушка")) counter.plugList.push({...item, article:item.price})
					if(item.name.startsWith("Скоба")) counter.stapleList.push({...item, article:item.price})
					if(item.name.startsWith("Профиль")) counter.profileList.push({...item, article:item.price})
					if(item.name.startsWith("Набор")) counter.kitList.push({...item, article:item.price})

					return counter
				},{
					stripList:[],
					connectorList:[],
					driverList:[],
					controllList:[],
					amplifierList:[],
					plugList:[],
					stapleList:[],
					profileList:[],
					kitList:[],
				})

				newArr.connectorList = newArr.connectorList.map(item =>{
					let connector = product.filter(product =>(item.Code === product.art))[0]
					 let connect = connector.name.split('(')[1]
					 connect = connect.substr(0,connect.indexOf(')'))
					return{...item, price:connector.price, connect:connect}
				})

				newArr.profileList = this.state.profileList.map(item =>{
					let profile = product.filter(product =>(item.Code === product.art))[0]
					return{...item, price:profile.price, kit:profile.Constructor[0].optArt}
				})

				newArr.stripList = this.state.stripList.map(item =>{
					let profile = product.filter(product =>(item.Code === product.art))[0]
					return{...item, price:profile.price}
				})

				this.setState({
					db:db,
					itemList:db,
					stripList:newArr.stripList,
					driverList:newArr.driverList,
					controllList:newArr.controllList,
					amplifierList:newArr.amplifierList,
					plugList:newArr.plugList,
					stapleList:newArr.stapleList,
					profileList:newArr.profileList,
					kitList:newArr.kitList,
					connectorList:newArr.connectorList
				})
			}
		);

	}

	getArrayFromAttribute(array, attribute) {
		let fullArray = array.map(item => {
			let intArray = item.Features.filter(item => {
				return item.Attribute === attribute
			})
			if (intArray.length>0){
				return intArray[0].value
			}
		})

		fullArray = fullArray.filter(item => (item))

		let result = this.delDuplicatesFromArray(fullArray)
		result.unshift('Выбрать')

		return result

	}

	getSeiesOptions(itemList, voltage){

		let numbArr = itemList.map(item => (item.name.split('LSR-')[1].substr(0,4)))
		let result = []

		if (voltage === '12') {
			result = numbArr.map(item =>{
				let descr = ''
				switch (item){
					case '5050': descr = 'PRO ' + item + ' (основное освещение)'; break;
					case '2835': descr = 'STANDARD ' + item + ' (декоративная)'; break;
					case '3528': descr = 'ECO ' + item + ' (декоративная)'; break;
				}
				return {
					num: item,
					description: descr
				}
			})
		}else if(voltage === '220'){
			result = numbArr.map(item =>{
				let descr = ''

				switch (item){
					case '5050': descr = 'PRO ' + item + ' (декоративная)'; break;
					case '2835': descr = 'STANDARD ' + item + ' (декоративная)'; break;
				}

				return {
					num: item,
					description: descr
				}
			})

		}

		result = this.delDuplicatesFromArray(result)

		result.unshift({num: 0, description: 'Выбрать'})
		return result

	}

	getFilteredArray(value = null, type = null){

		let itemList = this.state.stripList

		let voltage  =				type === 'voltage' ? value : this.state.filterVoltage
		let ip =							type === 'ip' ? value : this.state.filterIP
		let color =						type === 'color' ? value : this.state.filterColor
		let series =					type === 'series' ? value : this.state.filterSiries
		let lights =					type === 'lights' ? value : this.state.filterLights
		let power =						type === 'power' ? value : this.state.power

		if (type === 'voltage'){
			series = 'Выбрать'
			ip = 'Выбрать'
			color = 'Выбрать'
			lights = 'Выбрать'
		}

		// Фильтруем список по вольтажу
		if (voltage !== 'Выбрать') {
			itemList = this.state.stripList.filter(item => {
				let intArray = item.Features.filter(item => {
					return item.Attribute === 'Напряжение лампы В'
				})
				return intArray[0].value === voltage
			})
		}

		// Фильтруем список по IP
		if (ip !== 'Выбрать'){
			itemList = itemList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === "Степень защиты - IP_Name"})
				return intArray[0].value === ip
			})
		}
		// Фильтруем список по цвету
		if (color !== 'Выбрать'){
			itemList = itemList.filter(item =>item.color === color)}
		// Фильтруем список по серии
		if (series !== 'Выбрать'){
			let firstPart = series.split(' (')[0]
			let chosenSeries = firstPart.substr(firstPart.length-4, 4).trim()
			itemList = itemList.filter(item =>{
				return item.name.split('LSR-')[1].substr(0,4) === chosenSeries
			})
		}

		// Фильтруем список по количеству лампочек
		if (lights !== 'Выбрать'){
			itemList = itemList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === "Кол-во источников света на 1метр погонный"})
				return intArray[0].value === lights
			})
		}

		// Добавляем в список драйвер
		if (power !== 0){
			let driverList = this.state.driverList.filter(item =>{
				return	item.Code === power
			})
			itemList = itemList.concat(driverList)
		}
		return itemList
	}

	getAddFilteredArray(itemList, value = null, type = null){

		let voltage = this.state.filterVoltage
		let ip = this.state.filterIP
		let color = this.state.filterColor

		let controlColor =			type === 'controlColour' ? value : this.state.filterControllColor
		let control = 					type === 'control' ? value : this.state.filterControll
		let addStaple = 				type === 'addStaple' ? value : this.state.addStaple
		let addPlug = 					type === 'addPlug' ? value : this.state.addPlug
		let width = 						type === 'width' ? value : this.state.width
		let connector = 				type === 'connector' ? value : this.state.filterConnector
		let profile = 					type === 'profile' ? value : this.state.filterProfile

		// Фильтруем список по вольтажу
		let controllList = this.state.controllList
		let amplifierList = this.state.amplifierList
		let plugList = this.state.plugList
		let stapleList = this.state.stapleList
		let profileList = this.state.profileList
		let kitList = this.state.kitList
		let connectorList = this.state.connectorList

		// Фильтруем список контроллеров
		if (voltage !== 'Выбрать'){
			controllList = controllList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === "Напряжение на входе В"})
				if (intArray.length>0) {
					return intArray[0].value === voltage
				}
			})
		}

		if (ip !== 'Выбрать'){
			controllList = controllList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === "Степень защиты - IP_Name"})
				return intArray[0].value === ip
			})
		}

		// Фильтруем список коннекторов
		if (ip !== 'Выбрать'){
			connectorList = connectorList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === "Степень защиты - IP_Name"})
				if (intArray.length>0){
					return intArray[0].value === ip
				}
			})
		}
		if (color !== 'Выбрать'){
			if(color !== 'RGB'){
				color = 'Одноцветная'
			}
			connectorList = connectorList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === "Тип ленты_Name"})
				return intArray[0].value === color
			})
		}
		if (width !== 'Выбрать'){
			connectorList = connectorList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === "Ширина светодиодной ленты мм"})
				return intArray[0].value === width
			})
		}

		// Дополнительная фильтрация
		if (control !== 'Выбрать'){
			controllList = controllList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === "Передача сигнала - ПДУ_Name"})
				return intArray[0].value === control
			})
		}

		if (controlColor !== 'Выбрать'){
			controllList = controllList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === "Цвет корпуса ПДУ_Name"})
				return intArray[0].value === controlColor
			})
		}

		// Фильтруем список профилей
		if (width !== 'Выбрать'){
			if(Number(width) <= 11){
				width = '≤ 11'
		}
			profileList = profileList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === "Ширина светодиодной ленты мм"})
				return intArray[0].value === width
			})
		}
		if (profile !== 'Выбрать'){
			profileList = profileList.filter(item => (item.option === profile ))
		}

		if (!profileList.length){
			kitList = []
		}

		// Фильтруем список наборов для монтажа
		if (profile !== 'Выбрать'){
			kitList = kitList.filter(item => {
				let profile = profileList.filter(prof => prof.kit === item.Code)
				if (profile.length > 0){
					return profile[0].kit === item.Code
				}
			})
		}

		if (connector !== 'Выбрать'){
			connectorList = connectorList.filter(item =>(item.connect === connector))
		}

		// Добавляем к текущему списку объектов в корзине отфильтрованные дополнительные устройства
		itemList = itemList.concat(controllList).concat(kitList).concat(profileList).concat(connectorList)

		if(color === 'RGB'){
			if (ip !== 'Выбрать'){
				amplifierList = amplifierList.filter(item =>{
					let intArray = item.Features.filter(item => {return item.Attribute === "Степень защиты - IP_Name"})
					return intArray[0].value === ip
				})
			}
			itemList = itemList.concat(amplifierList)
		}


		if(voltage === '220'){

			// Фильтрация скобы
			if (color !== 'Выбрать'){
				if(color !== 'RGB'){color = 'Одноцветная'}
				stapleList = stapleList.filter(item =>{
					let intArray = item.Features.filter(item => {return item.Attribute === "Тип ленты_Name"})
					if(intArray.length > 0){return intArray[0].value === color}
				})
			}

			// Фильтрация заглушки
			if (color !== 'Выбрать'){
				if(color !== 'RGB'){color = 'Одноцветная'}
				plugList = plugList.filter(item =>{
					let intArray = item.Features.filter(item => {return item.Attribute === "Тип ленты_Name"})
					if(intArray.length > 0){return intArray[0].value === color}
				})
			}

			if(addStaple){itemList = itemList.concat(stapleList)}
			if(addPlug){itemList = itemList.concat(plugList)}

		}
		return itemList
	}

	changeFilterOptions(itemList, value = null, type = null){

		let voltage  =				type === 'voltage' ? value : this.state.filterVoltage
		let series =					type === 'series' ? value : this.state.filterSiries
		let ip =							type === 'ip' ? value : this.state.filterIP
		let color =						type === 'color' ? value : this.state.filterColor
		let lights =					type === 'lights' ? value : this.state.filterLights

		let colorOptions		  = this.state.colorOptions
		let ipOptions 				= this.state.ipOptions
		let siriesOptions 		= this.state.siriesOptions
		let lightsOptions 		= this.state.lightsOptions

		let enableInput = true

		if (type === 'voltage'){
			series = 'Выбрать'
			ip = 'Выбрать'
			color = 'Выбрать'
			lights = 'Выбрать'
		}


		if (color === 'Выбрать'){
			colorOptions = this.delDuplicatesFromArray(itemList.map(item =>item.color))
			colorOptions.unshift('Выбрать')
		}

		if (ip === 'Выбрать'){
			ipOptions = this.getArrayFromAttribute(itemList, "Степень защиты - IP_Name")
		}

		if (series === 'Выбрать'){
			siriesOptions = this.getSeiesOptions(itemList, voltage)
		}

		if (lights === 'Выбрать'){
			lightsOptions = this.getArrayFromAttribute(itemList, "Кол-во источников света на 1метр погонный")
		}

		if(this.state.itemList.length > 1 && (ip === 'Выбрать'
			|| color === 'Выбрать'
			|| series === 'Выбрать'
			|| voltage === 'Выбрать'
			|| lights === 'Выбрать')){

			enableInput = false
		}


		return this.setState({
			colorOptions:colorOptions,
			siriesOptions: siriesOptions,
			ipOptions: ipOptions,
			lightsOptions: lightsOptions,
			power: 0,
			controllOptions: [],
			controllColorOptions: [],
			connectorOptions: [],
			profileOptions:[],
			enableInput: enableInput
		})
	}

	changeAddFilterOptions(itemList, value=null, type=null){

		let control = 			type === 'control' ? value : this.state.filterControll
		let controlColour = type === 'controlColour' ? value : this.state.filterControllColor
		let connector = 		type === 'connector' ? value : this.state.filterConnector
		let profile = 			type === 'profile' ? value : this.state.filterProfile

		let controllOptions = this.state.controllOptions
		let controllColorOptions = this.state.controllColorOptions
		let connectorOptions = this.state.connectorOptions
		let profileOptions = this.state.profileOptions

		if (control === 'Выбрать') {
			controllOptions = this.getArrayFromAttribute(itemList, "Передача сигнала - ПДУ_Name")
		}

		if (controlColour === 'Выбрать') {
			controllColorOptions = this.getArrayFromAttribute(itemList, "Цвет корпуса ПДУ_Name")
		}

		if (connector === 'Выбрать') {
			connectorOptions = itemList.map(item => item.connect).filter(element => (element))
			connectorOptions = this.delDuplicatesFromArray(connectorOptions)
			connectorOptions.unshift('Выбрать')

		}

		if (profile === 'Выбрать') {
			profileOptions = itemList.map(item => {
				if (item.name.startsWith('Профиль')){
					return {title: item.option, img:item.img}
				}
			})
			profileOptions = profileOptions.filter(elem => elem)
			profileOptions = this.delDuplicatesFromArray(profileOptions)
			profileOptions.unshift({title:'Выбрать', img:''})

		}

		return this.setState({
			controllOptions:controllOptions,
			controllColorOptions:controllColorOptions,
			connectorOptions: connectorOptions,
			profileOptions:profileOptions
		})
	}

	getPowerOptions(voltage, power){

		// Фильтруем список по вольтажу
		let itemList = this.state.driverList.filter(item =>{
			let intArray = item.Features.filter(item => {return item.Attribute === 'Выход напряжение В'})
			return intArray[0].value === voltage
		})

		return itemList.filter(item =>{
			let intArray = item.Features.filter(item => {return item.Attribute === "Выход мощность Вт"})
			return intArray[0].value >= power
		})
	}

	// -- Служебные функции


// ++Кнопки
	getCustomButtons() {
		let elements = [];

		elements.push(
			<Button
				x="204"
				y="875"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.calcBtnIcon}
				text="Калькулятор освещенности"
				onClick={this.onBtnRedirectClick}
				key="redirect"
			/>
		);

		elements.push(
			<Button
				x="407"
				y="875"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pluginBtnIcon}
				text="Скачать плагин для DialuxС"
				onClick={this.onBtnPluginClick}
				key="plugin"
			/>
		);

		elements.push(
			<Button
				x="610"
				y="875"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				onClick={this.onBtnPrintPdfClick}
				key="printpdf"
			/>
		);

		elements.push(
			<Button
				x="813"
				y="875"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				onClick={this.onBtnPrintClick}
				key="print"
			/>
		);

		elements.push(
			<Button
				x="1017"
				y="875"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.excelBtnIcon}
				text="Сохранить в Excel"
				onClick={this.onBtnExcelClick}
				key="excel"
			/>
		);



		return elements;
	}
	//-- Кнопки

// ++ Обработка печати
	doPrint(params) {
		let _params = params || {};

		_params.data = {
			type:'led_strip',
			specList: JSON.stringify(this.state.specList)
		};

		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}
// -- Обработка печати

// ++ Обработка нажатия на кнопку
	onBtnPluginClick() {
		return open('https://www.dialux.com/en-GB/dialux-members/iek/')
	}

	onBtnRedirectClick() {
		return open('https://iek.ru/products/configurators/light-calc/')
	}

// -- Обработка нажатия на кнопку

	// Отрисовка Конфигуратора
	render() {
			return (
				<div className={styles.cfg}>
					{/*Логотип*/}
					<Image
						className={styles.logo}
						blockChangeScale={true}
					/>

					{/*Белый фон*/}
					< div style={{margin: '0 auto', backgroundColor: '#fff', width: '100%', height: '80px'}} />
					<div className={styles.pageTitle}>Конфигуратор подбора Светодиодной ленты</div>


					{/*Левая Часть*/}

					{/*Выбор лены*/}

					{/*Белый фон выбора ленты*/}
					<div style={{width: '400px', height: '190px', position:'absolute',left:'20px', top:'102px', margin: '0 auto', backgroundColor: '#fff'}} />
					<div className={styles.sectionTitle}>Выбор светодиодной ленты</div>

					{/*ДропДауны*/}
					{this.getCustomDropdown ? this.getCustomDropdown() : null}

					<span className={styles.additionVoltage}
								onPointerEnter={() => this.setState({showAdditionVoltInfo: true})}
								onPointerLeave={() => this.setState({showAdditionVoltInfo: false})}>&#63;</span>
					{this.state.showAdditionVoltInfo
					&& <span className={styles.showAdditionVoltage}>
						12 В — Позволяют создавать декоративное освещение мебели, ниш, барных стоек, рекламных конструкций,
						интерьера автомобиля, окон и витрин, а также подсветку деталей интерьера: многоуровневых и подвесных потолков,
				интерьера автомобиля, окон и витрин, а также подсветку деталей интерьера: многоуровневых и подвесных потолков,
				карнизов, плинтусов.
						<br/>
						<br/>
				220 В — Работает непосредственно от бытовой сети переменного тока и является отличным решением для
				архитектурной подсветки, благодаря высокой степени защиты IP67 и возможности последовательного подключения
				отрезков общей длиной до 100 метров.
					</span>}

					{/*Расчет длины*/}
					<span className={styles.lengthLabel}>Длина, м:</span>
					<input
						className={styles.length}
						type="number"
						min="0"
						onChange={this.onLengthInput}
						disabled={!this.state.enableInput}
						value={this.state.length}
					/>

					<span className={styles.additionLength}
								onPointerEnter={() => this.setState({showAdditionPowerInfo: true})}
								onPointerLeave={() => this.setState({showAdditionPowerInfo: false})}>&#63;</span>
					{this.state.showAdditionPowerInfo
					&& <span className={styles.showAdditionLength}>
						При добавлении ленты в корзину, добавляется одна упаковка
					</span>}


					{/*Полученная мощность*/}
					<span className={styles.powerLabel}>Мощность, Вт</span>
					<span className={styles.power}>{this.state.power}</span>

					<React.Fragment>
						<label className={styles.addDeviceLable}>
							Подбор дополнительных устройств:
						</label>
						<input
							className={styles.addDeviceCheckBox}
							type="checkbox"
							checked={this.state.showAdditionalFilters}
							onChange={this.toggleAddFilters}/>
					</ React.Fragment>

					{/*Дополнительные устройства*/}
					<div id='Addition'>
						{this.state.showAdditionalFilters
						&& <React.Fragment>

							<div style={{
								width: '400px',
								height: '220px',
								position: 'absolute',
								left: '20px',
								top: '327px',
								margin: '0 auto',
								backgroundColor: '#fff'
							}}/>
							<div className={styles.addSectionTitle}>Дополнительные устройства</div>

							{/*Дополнительные Заголовки*/}
							{this.getAddLable ? this.getAddLable() : null}

							{/*Дополнительные ДропДауны*/}
							{this.getAddCustomDropdown ? this.getAddCustomDropdown() : null}

							<Dropdown
								styles={{position:'absolute', top:'475px', left: '155px'}}
								activeValue={this.state.filterProfile}
								width={"100px"}
								items={this.state.profileOptions}
								click={this.onProfileChange}
								active={this.state.profileOptions.length > 1}
							/>

							{/*Дополнительные Чекбоксы*/}
							{this.state.filterVoltage === '220'
							&& this.getAddCheckBox ? this.getAddCheckBox() : null}

						</ React.Fragment>
						}</div>

					{/*Таблица отфильтрованных товаров*/}
					<LEDTable
						id='NoBucket'
						title='Лента и аксессуары, соответствующие выбранным параметрам'
						type='NoBucket'
						items={this.state.itemList}
						styles={{width: '400px', height: '484px', top: "327px", left: '20px', fontSize: '12px'}}
						onSelect={this.onListItemCheck}
						addBasket={this.addBasket}
						itemInfo={this.state.item}
					/>

					{/*Средняя часть*/}
					{/*Спецификация*/}
					<LEDTable
						title='Спецификация оборудования'
						type='Bucket'
						items={this.state.specList}
						styles={{width: '430px', height: '658px', top: "102px", left: '440px', fontSize: '12px', fontColor:'#37424a'}}
						onSelect={this.onListItemCheck}
						onDelete={this.onDelete}
						onChangeQuantity={this.onChangeQuantity}
					/>

					<div className={styles.sum}>Сумма: {this.state.summ} руб.</div>


					{/*Правая часть*/}
					{/* Артикул и имя */}
					<div className={styles.itemInfoBG}/>
					{this.state.item ? (
						<a href={`https://www.iek.ru/products/catalog/?page=detail&article=${this.state.item[0].art}`}
							 target="_blank">
							<div className={styles.itemInfo}>
								<div className={styles.itemInfo_Article}>{this.state.item[0].art}</div>
								<div>{this.state.item[0].name}</div>
							</div>
						</a>
					) : (
						<div className={styles.itemInfoNoArticle}/>
					)}

					{/* Фото */}
					<Image
						className={styles.itemImg}
						url={this.state.item && this.state.item[0].ImgPng[0].file_ref.uri ? this.state.item[0].ImgPng[0].file_ref.uri : null}
					/>

					{/* Описание */}
					{this.state.item && this.state.item[0].Description ? (
						<div className={styles.description}>{this.state.item[0].Description[0].desc_ru}</div>
					) : (
						<div className={styles.descriptionEmpty}/>
					)}


					{/*Кнопки*/}
					{this.getCustomButtons ? this.getCustomButtons() : null}


					{/*Подвал*/}
					{/* На основной сайт IEK */}
					<div style={{
						position: 'absolute',
						top: '928px',
						left: '623px',
						backgroundColor: '#37424a',
						width: '578px',
						height: '22px'
					}}/>
					<a  className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

					{/* Техническая поддержка */}
					<div style={{
						position: 'absolute',
						top: '928px',
						left: '20px',
						backgroundColor: '#fff',
						width: '603px',
						height: '22px'
					}}/>

					<a style={{
						position: 'absolute',
						top: '932px',
						left: '344px',
						color: '#37424a',
						width: '141px',
						height: '14px'
					}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
					</a>
					<span className={styles.techSupport}>+7 (495) 542-22-27</span>
				</div>
	)}
}

export default LEDStripConfigurator;



// WEBPACK FOOTER //
// ./src/react/LEDStripConfigurator.jsx